import React, { useState } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

interface PdfViewerProps {
	fileUrl: string;
	setReadComplete: (readComplete: boolean) => void;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ fileUrl, setReadComplete }) => {
	const [totalPages, setTotalPages] = useState<number>(0);

	const handlePageChange = (page: number): void => {
		if (totalPages > 0 && page === totalPages - 1) {
			setReadComplete(true);
		}
	};

	const onLoad = (pdf: any): void => {
		const numPages = pdf._pdfInfo.numPages;
		setTotalPages(numPages);
	};

	const calculateScale = () => {
		const scale = window.innerWidth / 800;
		return scale > 1 ? 1 : scale;
	};

	return (
		<div style={{ height: '70vh', width: '100%', overflowY: 'auto' }}>
			<Worker workerUrl="https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.min.js">
				<Viewer
					fileUrl={fileUrl}
					onPageChange={({ currentPage }: { currentPage: number }) => handlePageChange(currentPage)}
					onDocumentLoad={({ doc }: { doc: any }) => onLoad(doc)}
					defaultScale={calculateScale()}
				/>
			</Worker>
		</div>
	);
};

export default PdfViewer;
